import { Box, Grid, Typography } from "@mui/material";
import TemplateDashboard from "./TemplateDashboard";
import { TMenuOptions } from "../bannerColors";

export default function TemplateDashboardComOpcoes({
    color,
    type,
    gridCol = { md: 2.4 },
    items
}: TemplateDashboardComOpcoesProps) {

    return (
        <Grid container size={{xs: 2}} {...gridCol} spacing={2} alignSelf="flex-start">
                 <Grid size={{xs: 12}}>
                <TemplateDashboard {...{ type }} color={color} />
            </Grid>
             <Grid size={{xs: 12}}>
                <Box>
                {
                    items.map((item, index) => {
                        const itemHab = !item.disabled

                        return (
                            <Box
                                key={index}
                                gap={1}
                                p={0.3}
                                display="flex"
                                alignItems="center"
                                onClick={itemHab ? item.action : () => { }}
                                sx={{
                                    cursor: itemHab ? "pointer" : "default",
                                    transition: "0.2s",
                                    "&:hover": {
                                        bgcolor: itemHab ? "rgba(0,0,0,0.05)" : "unset"
                                    }
                                }}
                            >
                                {!item.icon && <Box width={13} height={19.5} />}
                                {item.icon && <Typography color={color} fontSize="small" sx={{ opacity: item.disabled ? 0.3 : "unset" }}>{item.icon}</Typography>}
                                <Typography color={color} variant="subtitle2" sx={{ opacity: item.disabled ? 0.4 : "unset" }}>{item.label}</Typography>
                            </Box>
                        )
                    })
                }
                </Box>
            </Grid>
        </Grid>
    )
}


interface TemplateDashboardComOpcoesProps {
    type: TMenuOptions
    color: string;
    gridCol?: {
        xs?: number,
        md?: number,
        lg?: number
    };
    items: Array<{
        label: string,
        icon?: JSX.Element,
        action: () => void,
        disabled?: boolean
    }>
}